import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const UploadHistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 24px;
  gap: 16px;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const Top = styled.div`
  display: flex;
  padding: 0px 10px;
  flex-direction: column;
  align-items: left;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};

  h2 {
    margin: 0;
    ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH3)}
    margin-bottom: 8px;
  }

  span {
    ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  }
`;

export const FailedCasesText = styled.span`
  color: ${(props) => props.theme.atlas.semantic.color.status.error.text};
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const TableWrapper = styled.div`
  margin-top: 20px;
  border-radius: 12px;
  ${(props) => props.theme.boxShadows.shadowLarge}
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  position: relative;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 400px;

  > div {
    flex: 0 1 auto;
    min-height: 0;
  }

  tbody tr {
    height: 72px;
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  margin-top: 16px;
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const RightContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  flex-wrap: nowrap;
`;

export const ShowingText = styled.span`
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
`;

export const StatusCellContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StatusDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const StatusDetailLine = styled.span<{
  $color: 'darkGrey' | 'lightGrey';
}>`
  color: ${(props) =>
    props.$color === 'darkGrey'
      ? props.theme.atlas.semantic.color.type.default
      : props.theme.atlas.semantic.color.type.muted};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
`;

export const ImportReportContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
`;

export const ImportReportHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;

  h3 {
    margin: 0;
    ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
    color: ${(props) => props.theme.atlas.semantic.color.type.default};
  }
`;

export const ImportReportMetricsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ImportReportMetricCard = styled.div`
  width: 239px;
  height: 140px;

  > div {
    width: 100%;
    height: 100%;
    min-width: unset;
  }
`;

export const ImportReportDividerWrapper = styled.div`
  margin-top: 32px;
  margin-bottom: 32px;
`;

export const ModalDescription = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  margin-bottom: 16px;

  span {
    font-weight: 600;
  }
`;
